import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { useCatalogPreferencesContext } from 'context/CatalogPreferencesContext';
import { useStorefrontContext } from 'context/StorefrontContext';

const HeaderSelectors: React.FC = () => {
  const { features } = useStorefrontContext();
  const {
    locale,
    currency,
    branchId,
    priceListId,
    branches,
    priceLists,
    setLocale,
    setCurrency,
    setBranchId,
    setPriceListId,
  } = useCatalogPreferencesContext();

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap">
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <InputLabel>Idioma</InputLabel>
        <Select label="Idioma" value={locale} onChange={(e) => setLocale(e.target.value)}>
          <MenuItem value="es-AR">ES</MenuItem>
          <MenuItem value="en">EN</MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <InputLabel>Moneda</InputLabel>
        <Select label="Moneda" value={currency} onChange={(e) => setCurrency(e.target.value)}>
          <MenuItem value="ARS">ARS</MenuItem>
          <MenuItem value="USD">USD</MenuItem>
        </Select>
      </FormControl>
      {branches.length > 0 && (
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Sucursal</InputLabel>
          <Select
            label="Sucursal"
            value={branchId ?? ''}
            onChange={(e) => setBranchId(e.target.value)}
          >
            {branches.map((b) => (
              <MenuItem key={b.id} value={b.id}>
                {b.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {features.b2bPriceListsEnabled && priceLists.length > 0 && (
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Lista</InputLabel>
          <Select
            label="Lista"
            value={priceListId ?? ''}
            onChange={(e) => setPriceListId(e.target.value)}
          >
            {priceLists.map((pl) => (
              <MenuItem key={pl.id} value={pl.id}>
                {pl.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <Box />
    </Stack>
  );
};

export default HeaderSelectors;
